/* eslint-disable */
import React, {useEffect, useState} from 'react'
import "./rincianTransaksi.style.css";
import Navbar from '../../component/Navbar'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClock, faCreditCard} from '@fortawesome/free-solid-svg-icons';
import {numberWithCommas} from '../../_helpers';
import moment from 'moment'
import Layout from '../../component/Layout';
import {cashbackServices, paymentServices} from '../../_services';
import Loading from '../../component/Loading';

const RincianTransaksi = () => {
    const [detailTransaction, setDetailTransaction] = useState();
    const [getCashback, setCashback] = useState();
    const [loading, setLoading] = useState(true);
    let query = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))

    useEffect(() => {
        paymentServices.detailTransaction(query.get('id')).then(res => {
            cashbackServices.getTransactionCashback(res[0].transNo).then(result => {
                setCashback(result)
            })
            setDetailTransaction(res[0])
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    }, [])

    const totalTransaction = detailTransaction?.items.reduce((acc, curValue) => acc + parseFloat(curValue.itemPrice) * curValue.qty, 0)
    const total = totalTransaction - (getCashback?.cashbackAmount || 0)
    const voucher = detailTransaction !== undefined ? detailTransaction.payments.reduce((acc, curValue) => acc + (curValue.ptypeCode === "VOUCHER" ? parseFloat(curValue.paymentAmount) : 0), 0) : []

    return (
        <Layout>
            <Navbar title='Rincian Transaksi'/>
            {detailTransaction !== undefined ?
                <>
                    <div className="has-background-light">
                        {loading ? <Loading/> : null}
                        <div className="column text-bold">Order Number <br/><p
                            className="font-large">{detailTransaction.transNo.substr(detailTransaction.transNo.length - 4)}</p>
                        </div>
                        <div className="column text-bold">Transaksi <br/>#{detailTransaction.transNo}</div>
                        <div className="columns is-mobile m-0">
                            <div className="column font-small">
                                <span className="has-text-black"><FontAwesomeIcon className="pink"
                                                                                  icon={faClock}/> {moment(detailTransaction.transDate).format("DD MMMM YYYY HH:mm")}</span>
                            </div>
                            <div className="column font-small">
                                <span className="has-text-black"><FontAwesomeIcon className="pink"
                                                                                  icon={faCreditCard}/> {detailTransaction.payments[0].ptypeCode}</span>
                            </div>
                        </div>
                    </div>
                    <div className="container px-2 pt-3">
                        <header className="has-text-black">
                            <p className="font-medium text-bold">Detail Pembelian</p>
                            <p className="font-small">{detailTransaction.locName}</p>
                        </header>
                        <hr/>
                        {detailTransaction.items.map((e, i) => (
                            <div key={i} className="py-1">
                                <p className="font-medium has-text-black">
                                    {e.itemName}
                                </p>
                                <p className="font-small">{e.description}</p>
                                <div className="level is-mobile">
                                    <div className="level-left font-small">
                                        Rp. {numberWithCommas(Math.round(e.itemPrice))} x {Math.round(e.qty)}
                                    </div>
                                    <div className="level-right font-small has-text-black">
                                        Rp {numberWithCommas(Math.round(e.itemPrice * e.qty))}
                                    </div>
                                </div>
                            </div>
                        ))}
                        <hr/>
                        <div className="level is-mobile pt-1 m-0">
                            <div className="level-left font-medium">
                                Subtotal
                            </div>
                            <div className="level-right font-small has-text-black">
                                Rp {numberWithCommas(totalTransaction)}
                            </div>
                        </div>
                        <hr/>
                        <p className="font-medium text-bold pt-1">Detail Pembayaran</p>
                        {detailTransaction.payments.length > 1 ?
                            detailTransaction.payments.map(value => {
                                return (
                                    <div className="level is-mobile font-small mb-0">
                                        <div className="level-left">
                                            {value.ptypeCode}
                                        </div>
                                        <div className="level-right font-small has-text-black">
                                            Rp {numberWithCommas(Math.round(parseInt(value.paymentAmount)))}
                                        </div>
                                    </div>
                                )
                            })
                            : <div className="level is-mobile font-small mb-0">
                                <div className="level-left">
                                    {detailTransaction.payments[0].ptypeCode}
                                </div>
                                <div className="level-right font-small has-text-black">
                                    Rp {numberWithCommas(Math.round(detailTransaction.totalAmt))}
                                </div>
                            </div>}

                        <hr/>
                        <div className="level is-mobile py-1">
                            <div className="level-left">
                                <div className="level-item">
                                    <div>
                                        <strong><p className="font-medium pink">TOTAL</p></strong>
                                        <p className="font-small">Harga sudah termasuk PB1</p>
                                    </div>
                                </div>
                            </div>
                            <div className="level-right">
                                <p className="font-medium text-bold has-text-black">Rp {numberWithCommas(Math.round(totalTransaction - voucher))}</p>
                            </div>
                        </div>

                        {getCashback !== undefined && getCashback !== null ?
                            <div className="level is-mobile font-small mb-0">
                                <div className="level-left">
                                    CASHBACK
                                </div>
                                <div className="level-right font-small has-text-black">
                                    Rp {numberWithCommas(Math.round(parseInt(getCashback.cashbackAmount)))}
                                </div>
                            </div> : null}

                        <br/>

                        <footer className="font-small mb-5">
                            <p className="text-bold">Note</p>
                            <p>{detailTransaction.remark.length === 0 ? "Tidak ada catatan" : detailTransaction.remark}</p>
                        </footer>
                    </div>
                </>
                : null}
        </Layout>
    )
}

export default RincianTransaksi
